'use strict';

var path = require('path');

var locatePath = require('locate-path');

module.exports = function (filename, opts) {
  opts = opts || {};
  var startDir = path.resolve(opts.cwd || '');
  var root = path.parse(startDir).root;
  var filenames = [].concat(filename);
  return new Promise(function (resolve) {
    (function find(dir) {
      locatePath(filenames, {
        cwd: dir
      }).then(function (file) {
        if (file) {
          resolve(path.join(dir, file));
        } else if (dir === root) {
          resolve(null);
        } else {
          find(path.dirname(dir));
        }
      });
    })(startDir);
  });
};

module.exports.sync = function (filename, opts) {
  opts = opts || {};
  var dir = path.resolve(opts.cwd || '');
  var root = path.parse(dir).root;
  var filenames = [].concat(filename); // eslint-disable-next-line no-constant-condition

  while (true) {
    var file = locatePath.sync(filenames, {
      cwd: dir
    });

    if (file) {
      return path.join(dir, file);
    } else if (dir === root) {
      return null;
    }

    dir = path.dirname(dir);
  }
};